const Selects = () => {
  jQuery(document).ready(function ($) {
    const customSelect = ".custom-select";

    $(customSelect).each(function () {
      const $select = $(this);
      const selectClass = $select.hasClass("light") ? "light" : "dark"; 

      $select.select2({
        templateResult: formatOption,
        templateSelection: formatOption,
        minimumResultsForSearch: Infinity,
        dropdownCssClass: `dynamic-dropdown-width ${selectClass}`,
      });

      $select.on("select2:open", function () {
        $(".select2-results__option").removeAttr("title");
        const selectedOption = $select.find("option:selected");
        selectedOption.prop("disabled", true);
        const selection = $(".select2-container .selection");
        const dropdown = $(".select2-container .dropdown-wrapper");
        const selectionWidth = selection.outerWidth();
        dropdown.css("width", `${selectionWidth}px`);
      });

      $select.on("select2:close", function () {
        $select.find("option").prop("disabled", false);
      });

      function removeTitleFromSelected() {
        const renderedSelection = $select.next('.select2-container').find('.select2-selection__rendered');
        renderedSelection.removeAttr('title');
      }
      removeTitleFromSelected();
    });

    function formatOption(option) {
      const imageUrl = $(option.element).data("image");
      if (!imageUrl) return option.text;

      return $(`
        <span class="option-span">
          <img src="${imageUrl}" class="option-img" alt="Option image" /> 
          ${option.text}
        </span>
      `);
    }
  });
};

export default Selects;
